import React, { Suspense } from 'react'
//import LandingImage from '../components/LandingImage/LandingImage'
import LandingImageWithRouting from '../components/LandingImageWithRouting/LandingImageWithRouting'
import { benefits, benefits2, benefits3 } from '../data/PreschoolText'
import GeneralInfo from '../components/GeneralInfo/GeneralInfo'
import TabContentButtonless from '../components/TabContentButtonless/TabContentButtonless'
import ContactInfo from '../components/ContactInfo/ContactInfo'
import NewsWrapper from '../components/NewsWrapper/NewsWrapper'
import image1 from '../images/events1.webp'
import image2 from '../images/events2.webp'
import image3 from '../images/events3.webp'
import image4 from '../images/events4.webp'
import image5 from '../images/events5.webp'
import image6 from '../images/events6.webp'
import image7 from '../images/events7.webp'
import image8 from '../images/events8.webp'
import image1Mini from '../images/events1-mini.webp'
import image2Mini from '../images/events2-mini.webp'
import image3Mini from '../images/events3-mini.webp'
import image4Mini from '../images/events4-mini.webp'
import image5Mini from '../images/events5-mini.webp'
import image6Mini from '../images/events6-mini.webp'
import image7Mini from '../images/events7-mini.webp'
import image8Mini from '../images/events8-mini.webp'
import kindergartenImage1 from '../images/kindergarten_events1.webp'
import kindergartenImage2 from '../images/kindergarten_events2.webp'
import kindergartenImage3 from '../images/kindergarten_events3.webp'
import kindergartenImage4 from '../images/kindergarten_events4.webp'
import kindergartenImage5 from '../images/kindergarten_events5.webp'
import kindergartenImage6 from '../images/kindergarten_events6.webp'
import kindergartenImage7 from '../images/kindergarten_events7.webp'
import kindergartenImage8 from '../images/kindergarten_events8.webp'
import kindergartenImage1Mini from '../images/kindergarten_events1-mini.webp'
import kindergartenImage2Mini from '../images/kindergarten_events2-mini.webp'
import kindergartenImage3Mini from '../images/kindergarten_events3-mini.webp'
import kindergartenImage4Mini from '../images/kindergarten_events4-mini.webp'
import kindergartenImage5Mini from '../images/kindergarten_events5-mini.webp'
import kindergartenImage6Mini from '../images/kindergarten_events6-mini.webp'
import kindergartenImage7Mini from '../images/kindergarten_events7-mini.webp'
import kindergartenImage8Mini from '../images/kindergarten_events8-mini.webp'
import image10 from '../images/facility2.webp'
// import image11 from '../images/facility.jpg'
import image12 from '../images/garden.webp'
import { Row, Col } from 'react-bootstrap'
const PhotoGalleryOneRow = React.lazy(()=> import('../components/PhotoGalleryOneRow/PhotoGalleryOneRow'))



function LandingPage() {

    const imagesBig = [image1, image2, image3, image4, image5, image6, image7, image8];
    const images = [image1Mini, image2Mini, image3Mini, image4Mini, image5Mini, image6Mini, image7Mini, image8Mini];
    const kindergartenImagesBig = [kindergartenImage1, kindergartenImage2, kindergartenImage3, kindergartenImage4, kindergartenImage5, kindergartenImage6, kindergartenImage7, kindergartenImage8]
    const kindergartenImages = [kindergartenImage1Mini, kindergartenImage2Mini, kindergartenImage3Mini, kindergartenImage4Mini, kindergartenImage5Mini, kindergartenImage6Mini, kindergartenImage7Mini, kindergartenImage8Mini]
    const captions = [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        ''
    ]

    const tabs1 = [
        'Τμήματα',
        'Παροχές',
        'Χώροι',
        'Στόχοι',
    ];

    const tabs2 = [
        'Γενικές πληροφορίες',
        'Παροχές',
        'Σχέδιο δράσης'
    ]

    const eventKeys1 = [

        'first',
        'second',
        'third',
        'fourth',
    ]

    const eventKeys2 = [
        'firstN',
        'secondN',
        'thirdN'
    ]

    // const contentBenefits = <TabContent eventKey="first"
    //     svgs={[<Svg1 />, <Svg2 />]}
    //     info={[
    //         <div>
    //             <Row>
    //                 <Col xs={12} sm={5}>
    //                     <h2>Μεταφορά</h2>
    //                     <p>{benefits}</p>
    //                 </Col>
    //                 <Col xs={12} sm={7} className="d-flex justify-content-center">
    //                     <img className='tab-content-image' src={image10} alt="metafora" />
    //                 </Col>
    //             </Row>
    //         </div>,
    //         <div>
    //             <Row>
    //                 <Col xs={12} sm={5}>
    //                     <h2>Φαγητό</h2>
    //                     <p>{benefits2}</p>
    //                 </Col>
    //                 <Col xs={12} sm={7} className="d-flex justify-content-center">
    //                     <img className='tab-content-image' src={image11} alt="fagito" />
    //                 </Col>
    //             </Row>
    //         </div>,
    //         <div>
    //             <Row>
    //                 <Col xs={12} sm={5}>
    //                     <h2>Επιμορφώσεις</h2>
    //                     <p>{benefits3}</p>
    //                 </Col>
    //             </Row>
    //         </div>]} />

    const contentBenefitsButtonless = <TabContentButtonless eventKey="second"
        info={<div>
            <Row>
                <Col xs={12} sm={5}>
                    <h2>Μεταφορά</h2>
                    <p>{benefits}</p>
                </Col>
                <Col xs={12} sm={7} className="d-flex justify-content-center">
                    <img className='tab-content-image' src={image10} alt="metafora" />
                </Col>
            </Row>
            <br />
            <Row>
                <Col xs={12} sm={10}>
                    <h2>Φαγητό</h2>
                    <p>{benefits2}</p>
                </Col>
                {/* <Col xs={12} sm={7} className="d-flex justify-content-center">
                    <img className='tab-content-image' src={image11} alt="fagito" />
                </Col> */}
            </Row>
            <br />
            <Row>
                <Col xs={10}>
                    <h2>Επιμορφώσεις</h2>
                    <p>{benefits3}</p>
                </Col>
            </Row>
        </div>} />

    const GoalsButtonless = <TabContentButtonless eventKey="fourth"
        info={<div>
            <Row>
                <Col xs={10} className="ps-3 pt-3">
                    <h2>Οι στόχοι μας</h2>
                    <p>Στόχος του Βρεφονηπιακού Σταθμού και Ιδιωτικού Νηπιαγωγείου είναι να συμβάλει στην ισόρροπη και ολόπλευρη ανάπτυξη των παιδιών. Σε όλες τις ηλικίες οι δραστηριότητες έχουν βιωματικό χαρακτήρα και δίνεται έμφαση τα παιδιά να έρθουν σε επαφή με την φύση και να αναπτύξουν συναισθήματα φιλικά προς το περιβάλλον, την οικολογία, την παράδοση και την προσφορά στον συνάνθρωπο.</p>
                </Col>
            </Row>
        </div>} />


    // const contentGoals = <TabContent title={<h1>Παιδικός Σταθμός</h1>} eventKey="second"
    //     svgs={[<Svg3 />, <Svg3 />, <Svg3 />]}
    //     info={[<div>
    //         <h2>stoxo1</h2>
    //         <p>sample text 1</p>
    //     </div>,
    //     <div>
    //         <h2>stoxo2</h2>
    //         <p>sample text 2</p>
    //     </div>,
    //     <div>
    //         <h2>stoxo3</h2>
    //         <p>sample text 3</p>
    //     </div>]} />

    const contentAreasButtonless = <TabContentButtonless title={<h1>Παιδικός Σταθμός</h1>} eventKey="third"
        info={<div>
            <Row>
                <Col xs={12} sm={10}>
                    <h2>Εγκαταστάσεις</h2>
                    <p>Οι εγκαταστάσεις είναι ιδιόκτητες, νεόδμητες και έχουν
                        σκοπό να εξυπηρετούν τις καθημερινές ανάγκες των παιδιών με
                        ασφάλεια και άνεση. Όλοι οι χώροι είναι ασφαλής, καθαροί, φωτεινοί
                        με παράθυρα ασφαλείας, με όμορφα χρώματα και παραστάσεις που
                        διεγείρουν την σκέψη και την αισθητική, εξάπτοντας την περιέργεια και
                        τη φαντασία των παιδιών. Υπάρχει πλούσιο οπτικοακουστικό υλικό για
                        τις παιδαγωγικές ανάγκες του σχολείου, με πολλά παιχνίδια
                        εκπαιδευτικά, ψυχαγωγικά, γωνιές ανατροφοδότησης και μεγάλη
                        βιβλιοθήκη.</p>
                </Col>
                {/* <Col xs={12} sm={7} className="d-flex justify-content-center">
                    <img className='tab-content-image' src={image10} alt="metafora" />
                </Col> */}
            </Row>
            <br />
            <Row>
                <Col xs={12} sm={5}>
                    <h2>Κήπος</h2>
                    <p>Υπάρχει μεγάλος καταπράσινος αύλειος χώρος με άπλετο φυσικό
                        ορίζοντα, φυσική σκίαση από δέντρα, μεγάλη παιδική χαρά με
                        παιχνίδια πιστοποιημένα ασφαλείας, δάπεδο ασφαλείας και πολλά
                        όργανα γυμναστικής. Τα παιδιά έχουν πρόσβαση και στο περιβόλι τού
                        σχολείου που υπάρχουν πολλά οπορωφόρα δέντρα, ελιές, αμπέλι,
                        μεγάλος λαχανόκηπος και μια μικρή φάρμα με οικόσιτα ζώα. Τα παιδιά
                        ζουν μέσα σε ένα πολύ όμορφο φυσικό περιβάλλον όπου
                        ανατροφοδοτούνται και αλληλεπιδρούν με αυτό. Στην μπροστινή όψη
                        του κτιρίου υπάρχει ανθόκηπος όπου τα παιδιά αναλαμβάνουν δράσεις
                        και απασχολούνται με αυτόν φυτεύοντας, ποτίζοντας ή φροντίζοντας
                        να διατηρείται σε καλή κατάσταση.</p>
                </Col>
                <Col xs={12} sm={7} className="d-flex justify-content-center">
                    <img className='tab-content-image' src={image12} alt="garden" />
                </Col>
            </Row>
            <br />
            <Row>
                <Col xs={12} sm={10}>
                    <h2>Στάθμευση</h2>
                    <p>Υπάρχει άνετος και ασφαλής χώρος στάθμευσης των αυτοκινήτων.</p>
                </Col>
            </Row>
        </div>} />
    // const contentClasses = <TabContent title={<h1>Παιδικός Σταθμός</h1>} eventKey="third"
    //     svgs={[<Svg4 />, <Svg5 />, <Svg6 />]}
    //     info={[<div>
    //         <h2>tmima1</h2>
    //         <p>sample text 1</p>
    //     </div>,
    //     <div>
    //         <h2>tmima2</h2>
    //         <p>sample text 2</p>
    //     </div>,
    //     <div>
    //         <h2>tmima3</h2>
    //         <p>sample text 3</p>
    //     </div>]} />
    const contentClassesButtonless = <TabContentButtonless title={<h1>Παιδικός Σταθμός</h1>} eventKey="first"
        info={<Row>
            <Col xs={12} sm={10}>
                <h2>ΒΡΕΦΙΚΟΣ ΣΤΑΘΜΟΣ</h2>
                <p>Στον Βρεφικό Σταθμό φιλοξενούνται
                    βρέφη ηλικίας από 12 μηνών έως 2,5 ετών. Προτεραιότητα της
                    Λιλιπούπολης είναι να προσφέρει σε αυτές τις τρυφερές
                    ηλικίες κλίμα στοργής, αγάπης, και ασφάλειας, δίνοντας
                    συνεχή κίνητρα και ερεθίσματα για τη σωστή ψυχοσωματική
                    και νοητική ανάπτυξή των βρεφών.</p>
                <br />
            </Col>
            <Col xs={12} sm={10}>
                <h2>ΠΑΙΔΙΚΟΣ ΣΤΑΘΜΟΣ</h2>
                <p>Ο Παιδικός Σταθμός φιλοξενεί παιδιά
                    από 2,5 ετών έως την εγγραφή τους στην υποχρεωτική
                    προσχολική εκπαίδευση. Μέσα από το παιχνίδι ομαδικό ή
                    ατομικό, από οργανωμένες ή αναδυόμενες δραστηριότητες,
                    δίνονται ευκαιρίες στα παιδία να αναπτύσσουν την
                    κοινωνικότητά τους, τις δεξιότητές τους, να παρατηρούν, να
                    συγκρίνουν, να βγάζουν συμπεράσματα, να δημιουργούν, να
                    ενισχύουν την αυτοπεποίθησή τους και να αυτονομούνται. Για
                    την πληρέστερη ψυχοσωματική ανάπτυξη των παιδιών
                    υπάρχει μεγάλη ποικιλία οργάνων γυμναστικής και γίνονται
                    μαθήματα παιδικής γιόγκα από παιδαγωγούς που κατέχουν
                    τον αντίστοιχο τίτλο εκπαίδευσης καθώς και θεατρικής
                    παιδείας.</p>
            </Col>
        </Row>} />
    // const contentBenefits2 = <TabContent title={<h1>Νηπιαγωγείο</h1>} eventKey="first"
    //     svgs={[<Svg1 />, <Svg2 />]}
    //     info={[<div>
    //         <h2>Μεταφορά</h2>
    //         <p>{benefits}</p>
    //     </div>,
    //     <div>
    //         <h2>Φαγητό</h2>
    //         <p>{benefits2}</p>
    //     </div>]} />

    const contentBenefitsButtonless2 = <TabContentButtonless eventKey="secondN"
        info={<div>
            <Row>
                <Col xs={12} sm={5}>
                    <h2>Μεταφορά</h2>
                    <p>{benefits}</p>
                </Col>
                <Col xs={12} sm={7} className="d-flex justify-content-center">
                    <img className='tab-content-image' src={image10} alt="metafora" />
                </Col>
            </Row>
            <br />
            <Row>
                <Col xs={12} sm={10}>
                    <h2>Φαγητό</h2>
                    <p>{benefits2}</p>
                </Col>
                {/* <Col xs={12} sm={7} className="d-flex justify-content-center">
                    <img className='tab-content-image' src={image11} alt="fagito" />
                </Col> */}
            </Row>
        </div>} />


    // const contentGoals2 = <TabContent title={<h1>Νηπιαγωγείο</h1>} eventKey="second"
    //     svgs={[<Svg3 />, <Svg3 />, <Svg3 />]}
    //     info={[<div>
    //         <h2>stoxo1</h2>
    //         <p>sample text 1 νηπιαγωγείο</p>
    //     </div>,
    //     <div>
    //         <h2>stoxo2</h2>
    //         <p>sample text 2 νηπιαγωγείο</p>
    //     </div>,
    //     <div>
    //         <h2>stoxo3</h2>
    //         <p>sample text 3 νηπιαγωγείο</p>
    //     </div>]} />

    const generalButtonless2 = <TabContentButtonless title={<h1>Νηπιαγωγείο</h1>} eventKey="firstN"
        info={
            <Row>
                <Col xs={12} sm={10}>
                    <h2>Γενικές πληροφορίες Νηπιαγωγείου</h2>
                    <p>Το τμήμα του Νηπιαγωγείου φιλοξενεί παιδιά 4 και 5 ετών. Το πρόγραμμα δραστηριοτήτων είναι εναρμονισμένο με τις εκάστοτε υποδείξεις του Υπουργείου Παιδείας. Δίνεται προτεραιότητα στην ανάπτυξη δεξιοτήτων των νηπίων, που θα αποτελέσουν εφόδιο για την μετάβασή τους στο σχολικό περιβάλλον του Δημοτικού Σχολείου. Προωθείται η εξωστρέφεια των παιδιών με εκδρομές και επισκέψεις εκπαιδευτικού και ψυχαγωγικού χαρακτήρα. Μέσα από το παιχνίδι και με τη βοήθεια πολυμέσων τα παιδιά έρχονται σε επαφή με την γλώσσα των Αγγλικών. Τα παιδιά εξοικειώνονται με την τεχνολογία και μαθαίνουν να την χρησιμοποιούν ώστε να αντλούν από αυτήν γνώσεις και εμπειρίες. Οργανώνονται φιλανθρωπικές δράσεις αλληλεγγύης προς τον συνάνθρωπο, δράσεις για την προστασία του περιβάλλοντος και προωθείται η υιοθέτηση υγιεινού τρόπου ζωής και διατροφής. Τα παιδιά έρχονται σε επαφή με τις τέχνες και μαθαίνουν να εκφράζονται και αυτά μέσα από αυτές, γνωρίζουν για την ιστορία και τον πολιτισμό της χώρας μας καθώς και πολιτισμούς άλλων χωρών και λαών. Αναπτύσσεται η αυτονομία και η αυτοκυριαρχία των παιδιών δίνοντας έμφαση και στην εξατομικευμένη παρέμβαση για κάθε παιδί.</p>
                </Col>
            </Row>} />

    const actionPlanButtonless = <TabContentButtonless title={<h1>Νηπιαγωγείο</h1>} eventKey="thirdN"
        info={
            <Row>
                <Col xs={12} sm={10}>
                    <p>Μπορείτε να κατεβάσετε το σχέδιο δράσης μας πατώντας <a href={`${process.env.PUBLIC_URL}/${encodeURI("objective.pdf")}`} download>εδώ</a></p>
                </Col>
            </Row>} />

    const preSchoolEventExtra = ''
    // <div className='events-general'>
    //     <p>Οι γιορτές των Εθνικών Επαιτειών, των Χριστουγέννων και λήξης της σχολικής χρονιάς δίνουν στα παιδία την ευκαιρία να λειτουργούν συλλογικά, να εκφράζονται μέσα από την τέχνη και να αναπτύσσουν την εξωστρέφειά τους. Επίσης γίνονται συχνές επισκέψεις σε επαγγελματικούς χώρους, συμμετοχή στα πολιτιστικά δρώμενα της πόλης, επισκέψεις σε επαγγελματικούς χώρους αλλά και προσκλήσεις διαφόρων επαγγελματιών και πολιτιστικών φορέων στον χώρο του σχολείου.</p>
    // </div>
    return (
        <>
            <LandingImageWithRouting />

            <GeneralInfo id='kindergarder' title="Παιδικός Σταθμός" tabs={tabs1} eventKeys={eventKeys1} tabContents={[contentClassesButtonless, contentBenefitsButtonless, contentAreasButtonless, GoalsButtonless]} defaultKey="first" />
            <Suspense fallback={"Φόρτωση..."}>
                <PhotoGalleryOneRow extraContent={preSchoolEventExtra} images={images} title={''} captions={captions} bigImages={imagesBig} />
            </Suspense>
            <GeneralInfo id='pre-school' title="Νηπιαγωγείο" tabs={tabs2} eventKeys={eventKeys2} tabContents={[generalButtonless2, contentBenefitsButtonless2, actionPlanButtonless]} defaultKey="firstN" />
            <Suspense fallback={"Φόρτωση..."}>
                <PhotoGalleryOneRow extraContent={preSchoolEventExtra} images={kindergartenImages} title={''} captions={captions} bigImages={kindergartenImagesBig} />
            </Suspense>
            <NewsWrapper />
            <ContactInfo />
        </>
    )
}

export default LandingPage
